var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var InstantCollapsible = /** @class */ (function (_super) {
    __extends(InstantCollapsible, _super);
    function InstantCollapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function (e) {
            _this.setState(function (prevState) { return ({ collapsed: !prevState.collapsed }); });
            e.stopPropagation();
        };
        _this.state = {
            collapsed: !_this.props.initiallyExpanded
        };
        return _this;
    }
    InstantCollapsible.prototype.render = function () {
        return (React.createElement("div", { className: "rj-instant-collapsible", "data-collapsed": this.state.collapsed },
            React.createElement("div", { className: "rj-instant-collapsible__trigger", onClick: this.toggle }, this.props.trigger),
            !this.state.collapsed && this.props.content));
    };
    return InstantCollapsible;
}(React.Component));
export { InstantCollapsible };
//# sourceMappingURL=InstantCollapsible.js.map